import { ReviewGroupWriterModel } from "../peerReviewGroupsApiSlice";
import { CoursePromptReviewGroup } from "./coursePromptReviewGroupsApiSlice";

export function getHighestGroupNumber(groupNames: string[]): number {
	const groupNamePattern = /^(?:Prompt )?Group (\d+)$/;

	const numbers = groupNames
		.map((name) => {
			const match = name.match(groupNamePattern);
			return match ? parseInt(match[1], 10) : null;
		})
		.filter((num) => num !== null);

	return numbers.length > 0 ? Math.max(...numbers) : 0;
}

export function makeNameString(
	group: CoursePromptReviewGroup,
	allWriters: ReviewGroupWriterModel[]
) {
	return group.studentIds
		.map((id) => {
			const student = allWriters.find((item) => item.id === id);
			return student ? student.fullName : "Unknown";
		})
		?.join(", ");
}
